import { PartnerPageData } from 'types/types'

export const isTBLPage = (page: PartnerPageData | null | undefined): boolean => {
  return page?.feature_flags?.is_tbl_page ?? false
}
